import { useCartQuery } from './useCartQuery';
import { useMemo } from 'react';
import { useRegisterRoute } from './useRegisterRoute';
import { type TicketData } from '@/api/registration';
import { TicketType } from '@/api/constant';

export function useInStockItem(ticket: TicketData) {
  const { eventId } = useRegisterRoute();
  const { data: cart } = useCartQuery(eventId);

  const result = useMemo(() => {
    if (!cart?.cartItems || !ticket.ticketSharedStockId || ticket.type === TicketType.Main) {
      return true;
    }

    const sharedStockItems = cart.cartItems.filter(
      (item) => { return item.ticketType === ticket.type && item.ticketSharedStockId === ticket.ticketSharedStockId; }
    );

    const totalSharedStockInCart = sharedStockItems.reduce(
      (sum, _) => { return sum + 1; },
      0
    );

    return ticket.currentStock > totalSharedStockInCart;
  }, [ticket.type, cart?.cartItems, ticket.ticketSharedStockId, ticket.currentStock]);

  return result;
}
